/*eslint complexity: ["error", 35]*/
/*eslint max-lines-per-function: ["error", 220]*/
import React from 'react';
import { Form, Row, Col, Alert } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateCardDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface PhysicalMeasurementsFieldsProps {
  card: CreateUpdateCardDto;
  propertyChange: (obj: Partial<CreateUpdateCardDto>) => void;
}

export const PhysicalMeasurementsFields: React.FC<
  PhysicalMeasurementsFieldsProps
> = ({ card, propertyChange }) => {
  return (
    <>
      <Alert variant="warning" className="mt-3">
        Wpisane odpowiedzi nadpiszą w karcie wynik z testów.
      </Alert>
      <Row>
        <Col md={6}>
          <FormRow controlId="height" label="Wzrost">
            <Form.Control
              type="text"
              value={card?.height || ''}
              onChange={e => propertyChange({ height: e.target.value })}
            />
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow controlId="weight" label="Masa ciała">
            <Form.Control
              type="text"
              value={card?.weight || ''}
              onChange={e => propertyChange({ weight: e.target.value })}
            />
          </FormRow>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow controlId="pulse" label="Tętno">
            <Form.Control
              type="text"
              value={card?.pulse || ''}
              onChange={e => propertyChange({ pulse: e.target.value })}
            />
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow controlId="bp" label="Ciśnienie tętnicze">
            <Form.Control
              type="text"
              value={card?.bp || ''}
              onChange={e => propertyChange({ bp: e.target.value })}
            />
          </FormRow>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow controlId="eyeRight" label="Wzrok - oko prawe">
            <Form.Control
              type="text"
              value={card?.eyeRight || ''}
              onChange={e => propertyChange({ eyeRight: e.target.value })}
            />
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow controlId="eyeLeft" label="Wzrok - oko lewe">
            <Form.Control
              type="text"
              value={card?.eyeLeft || ''}
              onChange={e => propertyChange({ eyeLeft: e.target.value })}
            />
          </FormRow>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow controlId="colorRecognition" label="Rozpoznawanie barw">
            <Form.Control
              type="text"
              value={card?.colorRecognition || ''}
              onChange={e =>
                propertyChange({ colorRecognition: e.target.value })
              }
            />
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow controlId="squint" label="Zez">
            <Form.Control
              type="text"
              value={card?.squint || ''}
              onChange={e => propertyChange({ squint: e.target.value })}
            />
          </FormRow>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow
            controlId="fieldOfVisionRight"
            label="Pole widzenia - oko prawe"
          >
            <Form.Control
              type="text"
              value={card?.fieldOfVisionRight || ''}
              onChange={e =>
                propertyChange({ fieldOfVisionRight: e.target.value })
              }
            />
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow
            controlId="fieldOfVisionLeft"
            label="Pole widzenia - oko lewe"
          >
            <Form.Control
              type="text"
              value={card?.fieldOfVisionLeft || ''}
              onChange={e =>
                propertyChange({ fieldOfVisionLeft: e.target.value })
              }
            />
          </FormRow>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow controlId="hearingRight" label="Słuch - ucho prawe">
            <Form.Control
              type="text"
              value={card?.hearingRight || ''}
              onChange={e => propertyChange({ hearingRight: e.target.value })}
            />
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow controlId="hearingLeft" label="Słuch - ucho lewe">
            <Form.Control
              type="text"
              value={card?.hearingLeft || ''}
              onChange={e => propertyChange({ hearingLeft: e.target.value })}
            />
          </FormRow>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow controlId="romberg" label="Romberg">
            <div>
              <Form.Check
                inline
                type="radio"
                label="wg testów"
                name="romberg"
                id="romberg-null"
                checked={card?.romberg === null || card?.romberg === undefined}
                onChange={() => propertyChange({ romberg: null })}
              />
              <Form.Check
                inline
                type="radio"
                label="Tak"
                name="romberg"
                id="romberg-true"
                checked={card?.romberg === true}
                onChange={() => propertyChange({ romberg: true })}
              />
              <Form.Check
                inline
                type="radio"
                label="Nie"
                name="romberg"
                id="romberg-false"
                checked={card?.romberg === false}
                onChange={() => propertyChange({ romberg: false })}
              />
            </div>
          </FormRow>
        </Col>
        <Col md={6}>
          <FormRow controlId="nystagmus" label="Oczopląs">
            <div>
              <Form.Check
                inline
                type="radio"
                label="wg testów"
                name="nystagmus"
                id="nystagmus-null"
                checked={
                  card?.nystagmus === null || card?.nystagmus === undefined
                }
                onChange={() => propertyChange({ nystagmus: null })}
              />
              <Form.Check
                inline
                type="radio"
                label="Tak"
                name="nystagmus"
                id="nystagmus-true"
                checked={card?.nystagmus === true}
                onChange={() => propertyChange({ nystagmus: true })}
              />
              <Form.Check
                inline
                type="radio"
                label="Nie"
                name="nystagmus"
                id="nystagmus-false"
                checked={card?.nystagmus === false}
                onChange={() => propertyChange({ nystagmus: false })}
              />
            </div>
          </FormRow>
        </Col>
      </Row>
    </>
  );
};
